import { ModifiersZTableModel } from '../../table.modifier';
import { TTableCellType, TTableOptions, TTableTreeModel } from '../../table.type';

export type TAutoPlanOrderRow = {
  suggestionId: string;
  otlId: string;
  oplId: string;
  factoryName: string;
  productType: string;
  line: string;
  loadStartDate: string;
  loadEndDate: string;
  plannedQty: number;
};

// Link action of the Line cell; the parent shows that suggestion on the board.
export const AUTO_PLAN_VIEW_ON_BOARD = 'VIEW_ON_BOARD';

const AUTO_PLAN_ORDER_COLUMNS: {
  key: Exclude<keyof TAutoPlanOrderRow, 'suggestionId'>;
  displayName: string;
  widthInPx: number;
}[] = [
  { key: 'otlId', displayName: 'OTL ID', widthInPx: 150 },
  { key: 'oplId', displayName: 'OPL ID', widthInPx: 150 },
  { key: 'factoryName', displayName: 'Factory', widthInPx: 150 },
  { key: 'productType', displayName: 'Product Type', widthInPx: 150 },
  { key: 'line', displayName: 'Line', widthInPx: 120 },
  { key: 'loadStartDate', displayName: 'Load Start Date', widthInPx: 150 },
  { key: 'loadEndDate', displayName: 'Load End Date', widthInPx: 150 },
  { key: 'plannedQty', displayName: 'Planned Qty', widthInPx: 100 },
];

const createHeaderRow = (): TTableOptions<TAutoPlanOrderRow>['headerConfig'] =>
  AUTO_PLAN_ORDER_COLUMNS.map((col) => ({
    type: 'TEXT_CELL' as const,
    text: col.displayName,
    widthInPx: col.widthInPx,
  }));

const getRows = (rowItem: TAutoPlanOrderRow): TTableCellType[] =>
  AUTO_PLAN_ORDER_COLUMNS.map((col) => ({
    type: 'TEXT_CELL' as const,
    text: rowItem[col.key],
    widthInPx: col.widthInPx,
    hrefActionCB: col.key === 'line' ? AUTO_PLAN_VIEW_ON_BOARD : undefined,
  }));

export const AUTO_PLAN_ORDER_TABLE_MODEL = {
  createModel: (rowInfo: TAutoPlanOrderRow[]): TTableTreeModel<TAutoPlanOrderRow> =>
    ModifiersZTableModel.createTableModel(
      rowInfo,
      {
        padding: 8,
        headerConfig: createHeaderRow(),
      },
      (item) => ({
        type: 'ROW' as const,
        rowItem: item,
        cells: getRows(item),
      }),
    ),
};
